import GetFlatOptions from "@/types/clients/esquire/requests/general/get-flat-options";
import OptionData from "@/types/clients/esquire/data/general/contract-data/option";
import esquire from "@/types/clients/esquire";
import GetReservationOptions
  , {ContractOptionsMap} from "@/types/clients/esquire/requests/general/get-reservation-options";

export const getFlatOptionsRequest = new GetFlatOptions(esquire);
export const getReservationOptionsRequest = new GetReservationOptions(esquire);

class OptionApi {

  async getFlatOptions(flatTypes: string[], nights: number): Promise<OptionData[]> {
    return await getFlatOptionsRequest.send(flatTypes, nights);

  }
  public async getReservationOptions(): Promise<ContractOptionsMap> {
    return await getReservationOptionsRequest.send();
  }
}

export default new OptionApi();
